import { gql } from "@apollo/client"

const GET_WEBSITES = gql`
  query GetWebsites($culture: String, $generalInfoRoute: String!) {
    contentDescendantsByAbsoluteRoute(
      route: $generalInfoRoute
      culture: $culture
      first: 1000
      where: { contentType: { alias: { in: ["groupSite"] } } }
    ) {
      nodes {
        id
        url
        key
        contentType {
          alias
        }
        namedProperties {
          ... on IGroupSite {
            siteName {
              value
            }
          }
        }
      }
    }
  }
`

export default GET_WEBSITES
